import { useFormik } from 'formik';
import React from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import BatchUploadFileForm from 'system/components/batch-management/file-managment/upload';
import { BatchUploadFileCrumbs } from '../constants';
import { BatchUploadFormInitialValues, BatchUploadFormValidationSchema } from './constants';
import { useEventCallback } from '@mui/material';
import { BatchUploadFormType } from './types';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { transformRequestGestioneBatchUploadFile } from './utils';
import { readFileAsBase64 } from 'shell/utils/file-to-base64';

const GestioneBacthUploadFile = (): React.ReactElement => {
  const batchUploadFile = useHttpClient(
    `${__PRACTICE_API_URL__}/pratiche/gestione-file-nfs/upload`,
    { options: { method: 'POST' } }
  );

  const navigate = useNavigate();

  const onSubmit = useEventCallback((formValues: BatchUploadFormType) => {
    const data = transformRequestGestioneBatchUploadFile(formValues);
    (
      batchUploadFile({
        data,
      }) as ResponsePromise<void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sistema/gestione-batch/gestione-file/download');
    });
  });

  const uploadForm = useFormik({
    initialValues: BatchUploadFormInitialValues,
    validationSchema: BatchUploadFormValidationSchema,
    onSubmit,
  });

  const handleAddFile = useEventCallback((file: File) => {
    readFileAsBase64(file).then((base64) => {
      uploadForm?.setFieldValue('file', {
        file,
        fileBaseTo64: base64,
      });
    });
  });

  return (
    <>
      <Breadcrumbs items={BatchUploadFileCrumbs} />

      <BatchUploadFileForm uploadFileFormContext={uploadForm} handleAddFile={handleAddFile} />
    </>
  );
};

GestioneBacthUploadFile.displayName = 'Gestione-batch upload file component';
export default GestioneBacthUploadFile;
